import { render } from "./SalonOverview.vue?vue&type=template&id=b1c4b52a"
import script from "./SalonOverview.vue?vue&type=script&lang=js"
export * from "./SalonOverview.vue?vue&type=script&lang=js"

import "./SalonOverview.vue?vue&type=style&index=0&id=b1c4b52a&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__